/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';
import { JiraRequestsGet } from './jira-requests.get';

export const AdminJiraGet = {
  id: 'admin-jira.get',
  tag: 'Admin',
  summary: 'Get Jira data',
  description: 'Get Jira data',
  method: 'get',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => `/administration/jira/requests`,
  request: {
    query: z.strictObject({
      requestStatus: z.string().optional(),
      take: z.string().optional(),
      skip: z.string().optional(),
    }),
  },
  response: {
    200: {
      description: 'successful',
      content: { 'application/json': { schema: JiraRequestsGet.response['200'].content['application/json'].schema } },
    },
  },
} as const satisfies Endpoint;
